var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"import-approval"},[_c('table-list',{attrs:{"title":"分销数据","loading":_vm.loading,"data":_vm.dataList,"columns":_vm.columns(this),"btns":_vm.btns(this),"operates":_vm.operates(this),"pager":_vm.pager},on:{"search":_vm.onSearch,"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }